import { supabase } from '../lib/supabase'
import type { Database } from '../types/database'

export type StudentPortfolio = Database['public']['Tables']['student_portfolios']['Row']

/** The career summary rows, in the order both the student and the teacher see them. */
export const PORTFOLIO_FIELDS = [
  { key: 'interests',     label: '興味、関心' },
  { key: 'career_vision', label: 'キャリアビジョン' },
  { key: 'strengths',     label: '強み' },
  { key: 'growth',        label: '成長' },
  { key: 'achievements',  label: '実績' },
  { key: 'advice',        label: '成長に向けたアドバイス' },
] as const

export type PortfolioFieldKey = typeof PORTFOLIO_FIELDS[number]['key']

export type StudentPortfolioFields = Pick<
  Database['public']['Tables']['student_portfolios']['Update'],
  PortfolioFieldKey
>

export function getCurrentFiscalYear(): number {
  const now = new Date()
  // month is 0-indexed; April = 3
  return now.getMonth() >= 3 ? now.getFullYear() : now.getFullYear() - 1
}

export class PortfolioService {
  static async getPortfolio(userId: string): Promise<StudentPortfolio | null> {
    const { data, error } = await supabase
      .from('student_portfolios')
      .select('*')
      .eq('user_id', userId)
      .eq('year', getCurrentFiscalYear())
      .maybeSingle()
    if (error) throw error
    return data
  }

  static async aiUpdatePortfolio(
    userId: string,
    aiValues: Partial<StudentPortfolioFields>
  ): Promise<StudentPortfolio> {
    const payload: Record<string, unknown> = {
      user_id: userId,
      year: getCurrentFiscalYear(),
      ...aiValues,
    }

    const { data, error } = await supabase
      .from('student_portfolios')
      .upsert(payload, { onConflict: 'user_id,year' })
      .select()
      .single()
    if (error) throw error
    return data
  }
}
